import React from "react";
import { useParams } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

const TITLES = {
  privacy: "Privacy Policy",
  terms: "Terms & Conditions",
  shipping: "Shipping Policy",
  cancellation: "Cancellation Policy",
  refund: "Refund Policy",
};

export default function PolicyPage() {
  const { type } = useParams();
  const { settings } = useSettings();
  const policies = settings?.policies || {};
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-serif text-4xl font-bold text-forest-dark mb-6" data-testid="policy-title">{TITLES[type] || "Policy"}</h1>
      <p className="text-charcoal/75 leading-relaxed whitespace-pre-line" data-testid="policy-body">
        {policies[type] || "This policy will be updated soon."}
      </p>
      <p className="text-charcoal/50 text-sm mt-8">For any questions, contact {settings?.contact?.email}.</p>
    </div>
  );
}
